<script setup lang="ts">
import { usePermissionsStore } from '@/modules/IdentityAndAccess/permissionsStore'
import FieldStatusDot from '@/modules/Project/Fields/FieldStatusDot.vue'
import type { Field } from '@/modules/Project/Fields/types'
import type { DotIndicatorReason } from '@/modules/Project/useDotIndicator'
import { useFieldRecompute } from '@/modules/Project/useFieldRecompute'

// This component exists so that `useFieldRecompute` is moved out of the immediate execution path
// of every cell in the project table. Otherwise, it's called for every cell in the table,
// which can impact performance.

defineProps<{
  field: Field
  reason: DotIndicatorReason
}>()

const { recomputeField } = useFieldRecompute()
const { canRecalculateEntities } = usePermissionsStore()
</script>

<template>
  <FieldStatusDot
    :reason="reason"
    :can-recompute="canRecalculateEntities"
    @recompute="recomputeField(field)"
  />
</template>
